
export function hello() {
  console.log(`Hello from ${NAME}`)
}

export const NAME = "UserPortal"
